/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userUsedCoupons.internal

import features.userUsedCoupons.models.UserCouponsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class UserUsedCouponsRequest : NetworkRequest() {

    suspend fun getUserUsedCoupons(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<UserCouponsModel> {
        return safeNetworkCall {
            get(
                endpoint = UserUsedCouponsEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
